document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const mainNavs = document.querySelectorAll('#header .mod_navigation');
  const modSearch = document.querySelector('#header .mod_search');
  const searchInput = modSearch?.querySelector('input[type="search"]');
  const buttonSearch = document.getElementById('button-search');

  const shouldCloseSearch = () => {
    return (
      searchInput &&
      document.activeElement !== searchInput &&
      searchInput.value.trim() === ''
    );
  };

  // Navigation öffnen/schließen
  mainNavs.forEach((nav) => {
    
    const button = document.getElementById('button-' + nav.id);
    if (!button) return;

    button.addEventListener('click', (e) => {
      console.log(button);
      e.stopPropagation();
      mainNavs.forEach((n) => n !== nav && n.classList.remove('open'));
      nav.classList.toggle('open');
    });

    nav.addEventListener('click', (e) => e.stopPropagation());
  });

  // Suche öffnen per Button
  if (buttonSearch) {
    buttonSearch.addEventListener('click', (e) => {
      e.stopPropagation();
      body.classList.add('search-open');
      searchInput?.focus();
    });
  }

  // Klick außerhalb: Navigation schließen + ggf. Suche
  document.addEventListener('click', (e) => {
    const target = e.target;
    const isInNavigation = Array.from(mainNavs).some((nav) =>
      nav.contains(target)
    );
    const isInSearch = modSearch && modSearch.contains(target);

    if (!isInNavigation && !isInSearch) {
      const navWasOpen = Array.from(mainNavs).some((nav) =>
        nav.classList.contains('open')
      );

      mainNavs.forEach((nav) => nav.classList.remove('open'));

      if (
        navWasOpen &&
        searchInput &&
        (searchInput === document.activeElement ||
          searchInput.value.trim() !== '')
      ) {
        body.classList.add('search-open');
      } else if (shouldCloseSearch()) {
        body.classList.remove('search-open');
      }
    }
  });
});
